import styles from "../RVLexicalEditor.module.scss";

/** Only highlight {{variable.name}} when on the same line (no newlines between {{ and }}). */
const CUSTOM_VARIABLE_REGEX = /\{\{[ \t]*[a-zA-Z0-9_.]+[ \t]*\}\}/g;

export function highlight(text: string) {
    return text.replace(CUSTOM_VARIABLE_REGEX, `<span class="${styles.customVariable}">$&</span>`);
}
